module.exports = __webpack_public_path__ + "static/media/Image-5.f6c0d2e4.png";